<template>
  <div v-if="$page" class="page">
    <header class="header -column">
      <h1 v-reveal="{ delay: 550 }" class="header__subtitle">{{ $page.header.hat }}</h1>
      <p v-reveal="{ delay: 600 }" class="header__title">{{ $page.header.title }}</p>
    </header>

    <section v-reveal="{ delay: 700 }" class="section -first -flower">
      <h2 v-reveal="{ delay: 700 }" class="section__title">
        {{ $page.services.title }}
      </h2>
      <div class="row">
        <RawHtml :html="$page.services.description" class="row__item -span-9" />
        <Image :source="$page.services.image" class="row__item -skip-1 support__badge" />
      </div>
      <RouterLink :to="$page.services.link" class="section__link">
        <span>{{ $page.services.label }}</span>
        <Icon id="leaves" class="button__icon" />
      </RouterLink>
    </section>

    <section id="services" class="section -first">
      <div class="support__services">
        <div
          v-for="(service, serviceKey) in $page.services.items"
          :key="serviceKey"
          class="support__service"
        >
          <h3 class="section__subtitle">{{ service.title }}</h3>
          <div class="support__services">
            <div
              v-for="(subService, subServiceKey) in service.items"
              :key="subServiceKey"
              class="support__service"
              :class="{ '-child': subServiceKey === 1 }"
            >
              <h4 v-if="subService.title" class="support__subtitle">
                {{ subService.title }}
              </h4>
              <RawHtml :html="subService.description" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="partenaires" class="section -first row__item -span-10">
      <h2 v-reveal="{ delay: 100 }" class="section__title">{{ $page.partners.title }}</h2>
      <RawHtml v-reveal="{ delay: 100 }" :html="$page.partners.description" />
      <p class="support__link">
        <RouterLink v-reveal="{ delay: 100 }" :to="$page.partners.link" class="section__link">
          {{ $page.partners.label }}
          <Icon id="leaves" />
        </RouterLink>
      </p>
    </section>

    <CtaContactSection
      v-reveal="{ delay: 100 }"
      :title="$page.contact.title"
      :subtitle="$page.contact.description"
      :link-label="$page.contact.label"
      route-name="involve"
    />
  </div>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import Image from '@/components/global/Image.vue'
import RawHtml from '@/components/global/RawHtml.vue'
import CtaContactSection from '@/components/sections/CtaContactSection.vue'
import { PageMetaMixin } from '@/mixins'

export default {
  name: 'Support',
  beetPage: 'services',
  mixins: [PageMetaMixin],
  components: { Image, CtaContactSection, Icon, RawHtml },
}
</script>
